import React, { useContext, useEffect, useState } from 'react';
import cl from './AddClient.module.css';  
import AddClientForm from '../../../Entity/Cars/Update/ClientForm/ClientForm';
import { AppContext } from '../../../../providers/appProvider';
import { useCar } from '../../../../hooks/useCar';
import { useNavigate } from 'react-router-dom'; 
import { validatePhoneNumber } from '../../../../utils/phone';
import { useTranslation } from 'react-i18next';
import Modal from '../../../UI/Modal/Modal';

const AddClient = ({ id }) => {
    const { t } = useTranslation();
        const [clientInfoModal, setClientInfoModal] = useState(false);
    
    let navigate = useNavigate();
    const { carService } = useCar(-1);
    const [newCar, setNewCar] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isFirstValidated, setIsFirstValidated] = useState(false)

    const [validates, setValidates] = useState({})
    const { appState, app } = useContext(AppContext);

    const validateCar = (car) => {
        const messages = {};
 
        if (car.client_id === 0) {

            if (!car.client.firstname || car.client.firstname.length < 2) {
                messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
            }

            if (!car.client.personal || car.client.personal.length < 11) {
                messages.personal = { message: 'მიუთითეთ 11 ნიშნა ციფრი', isValid: false };
            }


            if (!car.client.lastname || car.client.lastname.length < 2) {
                messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
            }


            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            if (!car.client.email || car.client.email.length < 2 || !emailRegex.test(car.client.email)) {
                messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
            }
 
            if (!car.client.mobile || !validatePhoneNumber(car.client.mobile)) {                
                messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
            }  
        } 
 
        if (car.searchedClients == 1) {
            messages.searchedClients = { message: 'აირჩიე ჩომოთვლილი კლიენტები', isValid: false };
        }


        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    useEffect(() => {
        if (isFirstValidated === true) {
            if (newCar) {
                const isValidate = validateCar(newCar)
            }
        }
    }, [newCar, isFirstValidated]);

    useEffect(() => {
   
            carService.getCarById(Number(id))
                .then(car => {
                    if (car) {
                        const editedCar = carService.initData(car)
                        setNewCar(editedCar)
                        setIsLoading(false);
                    } else {
                    }
                })
                .catch(error => {
                    console.error("Error fetching the car:", error);
                }); 
    }, []);

    if (isLoading || !newCar) {
        return <div>Loading...</div>;
    }

 
    const operateHandle = () => {

        let isValidate = validateCar(newCar)
 
        if (isValidate === true) {
            var updatedCar = {}

            updatedCar = {
                    ...newCar
            };

            delete updatedCar.searchedClients;
            delete updatedCar.transport_price;
 
            const successMessage = "წარმატებით დაემატა";

            
            if (!newCar || typeof newCar !== 'object') {
                console.error('Error: Invalid car data');
                app.setError('შეცდომა: არასწორი ავტომობილის მონაცემები');
                return;
            }
 
            carService.updateCarPage(updatedCar)
                .then(data => {
                    app.setOk(successMessage); 
                    navigate('/dealer/car/'+ id);
                    window.location.reload();

                    // navigate('/finances');
                })
                .catch(errorMessage => {
                    console.error('შეცდომა:', errorMessage);
                    if (errorMessage.includes("email")) {
                        app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("mobile")) {
                        app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("unique vin")) {
                        app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                    } else {
                        app.setError("შეცდომა: " + errorMessage);
                    }
                });

        } else {
            setIsFirstValidated(true)
        }
    };

 
    const handleClose = () => { 
        setClientInfoModal(false);   
    };


    return (
        <div>
            <span className={ cl.addClientBTN } onClick={() => setClientInfoModal(true)}>
                {t('Update')}
            </span>


            <Modal key={id} size="small" isOpen={clientInfoModal} onClose={handleClose}>
                <div className={cl.modalHead}>
                    <h3>{t('Update')}</h3>
                </div>  

                <div className={cl.newClientClass}>
                 
                               <AddClientForm newCar={newCar} setNewCar={setNewCar} validates={validates} >  </AddClientForm>


            <span onClick={operateHandle} style={{ marginLeft: 'auto' }} className={cl.btnPrimary}>{t('Save')}</span>

                </div>
            </Modal> 


        </div>
    );
};

export default AddClient;